import { Destination, HotelOptions, RoomFare, hotelProviderType } from 'features/quotation/types';
import { AccommodationServiceProviderTypeEnum } from 'features/common/components/AutocompleteAccomodationProviders';
import { ICodeName } from 'features/salesOrder/types';

export type AccommodationRoomDraft = {
	roomFareIndex: number;
	cost: number;
	locator: string;
};

/** Índice de tarifa en hotel.rooms alineado con roomBaseConfig (1 tarifa cotizada por habitación). */
export const getQuotedRoomFareIndex = (hotel: HotelOptions, roomIndex: number, roomCount: number): number => {
	if (hotel.rooms.length === roomCount && roomIndex < hotel.rooms.length) {
		return roomIndex;
	}
	if (roomIndex < hotel.rooms.length) {
		return roomIndex;
	}
	return 0;
};

export const getRoomFareForSlot = (hotel: HotelOptions, roomIndex: number, roomCount: number): RoomFare | undefined => {
	const fareIndex = getQuotedRoomFareIndex(hotel, roomIndex, roomCount);
	return hotel.rooms[fareIndex] ?? hotel.rooms[0];
};

export const initRoomDraftsFromHotel = (hotel: HotelOptions, roomCount: number): AccommodationRoomDraft[] =>
	Array.from({ length: roomCount }, (_, roomIndex) => {
		const roomFareIndex = getQuotedRoomFareIndex(hotel, roomIndex, roomCount);
		const fare = hotel.rooms[roomFareIndex] ?? hotel.rooms[0];
		return {
			roomFareIndex,
			cost: fare?.price ?? 0,
			locator: '',
		};
	});

export const hotelRoomsMatchRoomConfig = (hotel: HotelOptions, roomCount: number): boolean =>
	hotel.rooms.length > 0 && hotel.rooms.length === roomCount;

export const formatAccommodationDestination = (destination: Destination): ICodeName => {
	const name = destination.cityName?.trim() || destination.cityCode;
	return {
		code: destination.cityCode,
		name,
	};
};

export const mapHotelProviderToAccommodationType = (
	provider: hotelProviderType,
): AccommodationServiceProviderTypeEnum => {
	if (provider === 'MeVuelo') {
		return AccommodationServiceProviderTypeEnum.Mevuelo;
	}
	return AccommodationServiceProviderTypeEnum.Hotelbeds;
};
